export default __webpack_public_path__ + "static/mediumFont-e8e7fb7c731603be618d05a8e5dd8f57.woff";